import { httpsCallable } from "firebase/functions";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage, functions,auth } from "../firebase/firebase";

import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FileUpload = ({ setUploadProgress, setFileUrl }) => {
  
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(""); // State for storing file name

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name); // Set the file name
    } else {
      setFile(null);
      setFileName(""); // Clear file name
    }
  };

 const handleFileUpload = async (e) => {
   e.preventDefault();

   if (!file) {
      toast.error("Please select a file first!");
     return;
   }

   try {

    //  // Get the ID token of the authenticated user
     const user = auth.currentUser;
     if (!user) {
       throw new Error("User is not authenticated.");
     }

     const idToken = await user.getIdToken(); // Fetch the token
     console.log("ID Token:", idToken);


     // Start file upload to Firebase Storage
     const storageRef = ref(storage, `uploads/${file.name}`);
     const uploadTask = uploadBytesResumable(storageRef, file);

     uploadTask.on(
       "state_changed",
       (snapshot) => {
         const progress =
           (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
         setUploadProgress(progress);
         console.log("Upload is " + progress + "% done");
       },
       (error) => {
         console.error("File upload failed:", error);
        // toast.error("Failed to upload file");
       },
       async () => {
         const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
         console.log("Download URL:", downloadURL);

         // Call the Cloud Function and pass the download URL, along with ID token in headers
         const uploadDataOnFirebase = httpsCallable(
           functions,
           "uploadDataOnFirebase"
         );
         try {
           const res = await uploadDataOnFirebase(
             { downloadURL: downloadURL },
             {
               headers: {
                 Authorization: `Bearer ${idToken}`, // Include the token here
               },
             }
           );
          //  console.log("UPLOAD DATA RESULT: ", res.data);
           setFileUrl(downloadURL);
           console.log("File uploaded to Firebase successfully.");
           toast.success("File uploaded and data processed successfully");
         } catch (error) {
           console.error("Error calling Cloud Function:", error);
             toast.error("Failed to process data after upload");
         }
       }
     );
   } catch (error) {
     console.error("Error handling file upload:", error);
    toast.error(error.message);
   }
 };

  return (
    <form onSubmit={handleFileUpload}>
      <div className="flex mt-2 items-start">
        <div className="flex items-start border border-gray-300 rounded-sm overflow-hidden w-96 ">
          <label
            htmlFor="fileInput"
            className="bg-gray-200 px-4 py-2 border-r border-gray-300 cursor-pointer text-xs"
          >
            Choose daily price file
          </label>
          <input
            type="file"
            id="fileInput"
            className="hidden"
            onChange={handleFileChange}
          />
          <span className="px-4 py-2 text-gray-500 text-xs">
            {fileName || "No file chosen"}{" "}
            {/* Display the file name or placeholder */}
          </span>
        </div>

        <button
          type="submit"
          className="ml-4 bg-blue-800 text-white px-4 py-2 rounded-sm text-sm h-8 text-center"
        >
          Upload
        </button>
      </div>
    </form>
  );
};

export default FileUpload;
